import React from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../../App';
import { t } from '../../lib/i18n';
import { Seo } from './Seo';
import { TAGLINE } from '../../seo/seoConfig.mjs';

const TITLE_BY_PREFIX = [
  ['/admin/support', 'adminInbox'],
  ['/simulation/compare', 'compareTitle'],
  ['/simulation', 'simulation'],
  ['/dashboard', 'dashboard'],
  ['/coach', 'coach'],
  ['/progress', 'progress'],
  ['/routine', 'routine'],
  ['/history', 'history'],
  ['/settings', 'settings'],
];

/**
 * SEO for authenticated app areas: descriptive tab title, never indexed,
 * no canonical / hreflang (private content must not leak into search engines).
 */
export const PrivateSeo = ({ titleKey, title }) => {
  const { language } = useLanguage();
  const location = useLocation();
  const match = TITLE_BY_PREFIX.find(([prefix]) => location.pathname === prefix || location.pathname.startsWith(`${prefix}/`));
  const key = titleKey || (match ? match[1] : null);
  const label = title || (key ? t(key, language) : null);
  const fullTitle = label && label !== key ? `${label} \u00b7 PrimeFace` : 'PrimeFace';
  return <Seo title={fullTitle} robots="noindex, nofollow" lang={language} description={TAGLINE[language] || TAGLINE.fr} />;
};
